module.exports = __webpack_public_path__ + "static/assets/cc6448c06289b022a002259094d46020.png";